export default __webpack_public_path__ + "static/media/90.8924c083.svg";